import React, { useCallback, useEffect, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import format from "date-fns/format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Styles from "./index.module.css";
import { getAndStoreDateRangeKPIs, useAppDispatch } from "../../redux";
import moment from "moment";

interface DateSelectionRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

export const DateRange: React.FC<{
  setDateRange: (s: moment.Moment, e: moment.Moment) => void;
}> = ({ setDateRange = () => {} }) => {
  const dispatch = useAppDispatch();
  // const calendarIcon: IconProp = faCalendarAlt;

  const selectionRange: DateSelectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  };

  const [SelectedDates, setSelectedDates] =
    useState<DateSelectionRange>(selectionRange);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const GetAndStoreKPIs = useCallback(async () => {
    dispatch<any>(
      getAndStoreDateRangeKPIs({
        start_date: moment(SelectedDates.startDate),
        end_date: moment(SelectedDates.endDate),
      }),
    );
  }, [dispatch, SelectedDates.startDate, SelectedDates.endDate]);

  useEffect(() => {
    GetAndStoreKPIs();
  }, [GetAndStoreKPIs]);

  const handleSelect = (ranges: any) => {
    const selection = ranges?.selection;

    if (selection?.startDate && selection?.endDate) {
      setDateRange(moment(selection.startDate), moment(selection.endDate));

      setSelectedDates({
        startDate: selection.startDate,
        endDate: selection.endDate,
        key: "selection",
      });
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Button
        aria-describedby={id}
        variant="outlined"
        color="primary"
        style={{ color: "#fff" }}
        onClick={handleClick}
      >
        <FontAwesomeIcon
          size="1x"
          className={Styles.CalenderIcon}
          color="#ffffff"
          icon={faCalendarAlt}
        />
        {format(SelectedDates.startDate, "PP")} -{" "}
        {format(SelectedDates.endDate, "PP")}
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <DateRangePicker ranges={[SelectedDates]} onChange={handleSelect} />
      </Popover>
    </>
  );
};
